import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { Point } from "appworks/utils/geom/point";
import { PartnerConnectWaysResult } from "partner-connect/integration/builders/results/partner-connect-ways-result";
import { PartnerConnect } from "partner-connect/partner-connect-manager";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export class PartnerConnectWaysResultsBuilder implements ResultBuilder {

    public filter(response: PartnerConnect.SpinResponseBet): boolean {
        return response?.eventdata?.response?.cashWin > 0 && response?.eventdata?.response?.clientData?.spinCalcResult?.winsWays?.length > 0;
    }

    public build(record: SpinRecord, response: PartnerConnect.SpinResponseBet): Result[] {
        const results: Result[] = [];

        for (const winData of response.eventdata.response.clientData.spinCalcResult.winsWays) {
            const result = new PartnerConnectWaysResult();
            result.symbolType = winData.winSymbol;
            result.cashWon = Math.round(winData.winAmountResult * 100);
            result.positions = [];
            for (const resultPosition of winData.winSymbolsLocations) {
                result.positions.push(new Point(resultPosition.xReelIndex, resultPosition.yReelViewIndex));
            }
            result.ways = winData.waysCombinationsCount;
            result.matches = winData.totalSymbolsCount;
            result.step = response.step;
            result.createWaysSymbols(record);
            result.flattenWaysSymbols();
            results.push(result);
        }

        return results;
    }

    protected convertSymbolIDs(symbols: string[][]): string[][] {
        return symbols.map(
            (reel) => reel.map(
                (symbol) => slotDefinition.symbolDefinitions[symbol].id
            )
        );
    }
}

export const partnerConnectWaysResultsBuilder = new PartnerConnectWaysResultsBuilder();
